import { AreasModule } from './areas/areas.module';
import { NgModule, Injectable, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '@tech-environments/environment';
import { IConfig, NgxMaskModule } from 'ngx-mask';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TechLibPortalModule, CommonService } from '@techrules/portallib';
import { registerLocaleData } from '@angular/common';
import * as Hammer from 'hammerjs';
import {
  BrowserModule,
  HammerGestureConfig,
  HammerModule,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SessionService } from '@tech-services/session.service';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

import localeEs from '@angular/common/locales/es';
import localePT from '@angular/common/locales/pt';
import localeNl from '@angular/common/locales/nl';
import localeAr from '@angular/common/locales/ar';
import localeMx from '@angular/common/locales/es-MX';

import { AppConfig } from './utils/app-config.service';
import { TechLibPipeModule } from '@techrules/pipelib';
import { BussinesAreaService } from '@tech-services/bussines-area.service';

registerLocaleData(localeEs, 'es');
registerLocaleData(localePT, 'pt');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeMx, 'es-MX');

const urlParams = new URLSearchParams(window.location.search);
const paramIsClient = urlParams.get('IsClient');
const paramClientCode = urlParams.get('ClientCode');
const paramDomain = urlParams.get('Domain');
const paramLanguage = urlParams.get('Language');
const paramSessionToken = urlParams.get('SessionClientToken');
const paramUserCode = urlParams.get('UserCode');
const paramAssetId = urlParams.get('AssetId');

const configTech = {
  appName: 'PortalClient',
  baseApi: '',
  language: '',
  domain: '',
  sessionToken: '',
  accessToken: '',
  userCode: '',
  apiKey: '',
  AssetId: '',
  formatsTech:
    '[",",".",",",2,"€","s", "R","R","U",0,-10000,"-","+","L", "%","dd/MM/yyyy"]', //ser.formatsStr,
  clientCode: '',
  domainData: '',
  smsCode: '',
  base: '',
  angularAppsBase: '',
  baseOnboarding: '',
  tabTitle: '',
  currencySymbolBase: '',
  currencyBase: '',
  reCaptchaKey: '',
  minLengthPass: 0,
  passRequirement: '',
  production: '',
  useApiRest: '',
  SMSVerification: '',
  IsResident: '',
  IsForeigner: '',
  defaultCodeCountry: '',
  defaultCodeCountryPhone: '',
  backgroundEffect: '',
  toNewQuestionnaire: '',
  RoboOperationsValidation: '',
  ContactEmailOperations: '',
  custodian: '',
};

const pipeConfig = {
  language: 'es',
  groupSeparator: ',',
  decimalSeparator: '.',
  numberOfDecimals: '2',
  // baseCurrenncy: 'EUR',
  shortDatePattern: 'DD/MM/yyyy',
  formatsTech:
    '[",",".",",",2,"€","s", "R","R","U",0,-10000,"-","+","L", "%","DD/MM/yyyy"]',
  // symbolPosition: '',
  customCurrencySymbols: [],
  customCurrencyPosition: '',
};

let reCaptchaKey = '';
const translateConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: (http: HttpClient) => {
      return new TranslateHttpLoader(
        http,
        environment.baseAssets + 'i18n/',
        '.json?v=' + Date.now()
      );
    },
    deps: [HttpClient],
  },
};

const disableAnimations =
  !('animate' in document.documentElement) ||
  (navigator && /iPhone OS (8|9|10|11|12|13)_/.test(navigator.userAgent));

// export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
//   parse(url: string): UrlTree {
//     return super.parse(url.toLowerCase());
//   }
// }

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: Hammer.DIRECTION_ALL },
    pinch: { enable: false },
    rotate: { enable: false },
  };
}

@NgModule({
  declarations: [AppComponent],
  exports: [RecaptchaV3Module],
  imports: [
    AreasModule,
    AppRoutingModule,
    BrowserModule,
    //BrowserAnimationsModule,
    HammerModule,
    RecaptchaV3Module,
    NgxMaskModule.forRoot(options),
    TranslateModule.forRoot(translateConfig),
    TechLibPortalModule.initializeApp(configTech),
    TechLibPipeModule.initializeApp(pipeConfig),
    BrowserAnimationsModule.withConfig({ disableAnimations }),
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [AppConfig, SessionService, BussinesAreaService],
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: () => AppConfig.settings.reCaptchaKey,
      deps: [AppConfig],
      //useValue: AppConfig.settings.reCaptchaKey,
    },
  ],
})
export class AppModule {
  constructor() {}
}

export function initializeApp(
  appConfig: AppConfig,
  ser: SessionService,
  demoService: BussinesAreaService
) {
  return (): Promise<any> => {
    return appConfig.load().then(() => {
      const data = AppConfig.settings;
      reCaptchaKey = data.reCaptchaKey;
      configTech.baseApi = data.baseApi;
      configTech.language = ser.language;
      configTech.domain = ser.domain;
      configTech.sessionToken = ser.sessionToken;
      configTech.accessToken = ser.sessionToken;
      configTech.formatsTech =
        '[",",".",",",2,"€","s", "R","R","U",0,-10000,"-","+","L", "%","dd/MM/yyyy"]';
      configTech.clientCode = ser.clientCode;
      (configTech.base = data.base),
        (configTech.angularAppsBase = data.angularAppsBase),
        (configTech.baseOnboarding = data.baseOnboarding),
        (configTech.tabTitle = data.tabTitle);
      (configTech.currencySymbolBase = data.currencySymbolBase),
        (configTech.currencyBase = data.currencyBase),
        (configTech.reCaptchaKey = data.reCaptchaKey),
        (configTech.minLengthPass = Number(data.minLengthPass)),
        (configTech.passRequirement = data.passRequirement),
        (configTech.production = data.production),
        (configTech.useApiRest = data.useApiRest),
        (configTech.SMSVerification = data.SMSVerification),
        (configTech.IsResident = data.IsResident),
        (configTech.IsForeigner = data.IsForeigner),
        (configTech.defaultCodeCountry = data.defaultCodeCountry),
        (configTech.defaultCodeCountryPhone = data.defaultCodeCountryPhone),
        (configTech.backgroundEffect = data.backgroundEffect),
        (configTech.toNewQuestionnaire = data.toNewQuestionnaire),
        (configTech.RoboOperationsValidation = data.RoboOperationsValidation),
        (configTech.ContactEmailOperations = data.ContactEmailOperations),
        (configTech.custodian = data.custodian);
      localStorage.setItem('Language', ser.language);
      localStorage.setItem('Domain', ser.domain);

      pipeConfig.shortDatePattern = 'DD/MM/yyyy';
      pipeConfig.customCurrencySymbols = data.customCurrencySymbols;
      pipeConfig.customCurrencyPosition = data.customCurrencyPosition;
      pipeConfig.language = ser.language;

      demoService
        .getBussinesAreaData2(AppConfig.settings.domain)
        //.pipe(takeUntil(this.unsubscribe$))
        .subscribe((data) => {
          pipeConfig.decimalSeparator = data.Formats.DecimalSeparator;
          pipeConfig.groupSeparator = data.Formats.GroupSeparator;
        });
    });
  };
}
